import { DateFormat } from "../../DateFormat";
import { add } from "../base";
export class Base {
    separator;
    constructor(separator) {
        this.separator = separator;
    }
    partialFormat(unformatted) {
        const formatted = this.format(unformatted);
        return {
            ...formatted,
            remainder: this.formatString.slice(formatted.value.length),
        };
    }
    unformat(formatted) {
        return formatted.delete(this.separator);
    }
    validMonth(day, month, year) {
        return (new Date(Number.parseInt(year ?? "2004"), Number.parseInt(month), 0).getDate() >=
            Number.parseInt(day));
    }
}
const handlers = {};
export function register(format, create) {
    handlers[format] = create;
}
add("date", (parameters) => {
    const argument = parameters && parameters.length > 0 ? parameters[0] : undefined;
    const format = DateFormat.is(argument) ? argument : DateFormat.fromLocale(argument);
    const create = handlers[format] ?? handlers["YYYY-mm-dd"];
    return create();
});
//# sourceMappingURL=Base.js.map